"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var LegalActionOutlook_1 = require("../../../components/Pages/LegalActionOutlook/LegalActionOutlook");
var withRouter_1 = require("../../hooks/withRouter");
var ActionOutlook = function (props) {
    return React.createElement(LegalActionOutlook_1.default, { reference: props.router.params.reference });
};
exports.default = (0, withRouter_1.default)(ActionOutlook);
